import { Box, Loader } from '@ksyos/design-system';
import { useGetDataErrors } from '@frontend/components/pages/practitioners/dataErrors/hooks/useGetDataErrors';
import PractitionerChecksTable from './PractitionerChecksTable';

export function PractitionerChecks() {
    const {
        data: { items },
        isLoading,
    } = useGetDataErrors();

    return (
        <>
            {isLoading ? (
                <Box
                    alignItems="center"
                    display="flex"
                    flex={1}
                    justifyContent="center"
                    minHeight="300px"
                >
                    <Loader size="small" />
                </Box>
            ) : (
                <PractitionerChecksTable items={items} />
            )}
        </>
    );
}
